import React, {PropTypes} from 'react';

import EventPriceDetailsModalContainer from './eventPriceDetailsModal/EventPriceDetailsModalContainer.jsx';
import ErrorListContainer from './error/ErrorListContainer.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const OrderReview = ({
  title,
  total,
  children
}) => (
  <div>
    <EventPriceDetailsModalContainer />
    <div className="panel panel-primary">
      <div className="panel-heading">
        <h2 className="panel-title">{title}</h2>
      </div>
      <div className="panel-body">
        <ErrorListContainer />

        {children}

        <hr />

        <h4 className="text-right">
          <strong>{`Total: $`}{total.formatCurrency(2)}</strong>
        </h4>
      </div>
    </div>
  </div>
);

OrderReview.defaultProps = {
  title: 'Order Review',
  total: 0
};

OrderReview.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  children: PropTypes.node
};

export default OrderReview;



// WEBPACK FOOTER //
// ./src/features/shared/OrderReview.jsx